<template>
    <div>
        <div class="object-titlebox">
            <div class="object-titlebox-left">
                <span v-t="'message.item_device_management_list'"></span>
            </div>
        </div>
        <div class="treetitle" style="height: 56px">
            <el-form
                @submit.native.prevent="getDeviceManagementList(conditionType, searchString, searchApprovalStatus, active, false, true)"
                style="padding-left: 20px;padding-top:5px">
                <div style="display: flex;">
                    <div style="width: 160px">
                        <el-select class="search-item" v-model="conditionType">
                            <el-option style="font-size:12px" value="all"
                                :label="$t('message.item_search_all')"></el-option>
                            <el-option style="font-size:12px" value="deviceId"
                                :label="$t('message.item_device_id')"></el-option>
                            <el-option style="font-size:12px" value="approvalStatus"
                                :label="$t('message.item_approval_status')"></el-option>
                            <el-option style="font-size:12px" value="active"
                                :label="$t('message.item_active')"></el-option>
                        </el-select>
                    </div>
                    <div v-if="conditionType === 'deviceId'">
                        <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString"
                            class="object-search-select" style="padding-left:0px;width:350px;" clearable
                            @clear="searchString = ''" minlength="32" maxlength="32" show-word-limit />
                    </div>
                    <div v-else-if="conditionType === 'approvalStatus'">
                        <el-select :placeholder="$t('message.place_holder_select_item')" v-model="searchApprovalStatus"
                            class="object-search-select" style="padding-left:0px;width:350px;">
                            <el-option style="font-size:12px" :value="DEVICE_MANAGEMENT_STATUS_UNAPPROVED"
                                :label="$t('message.item_approval_status_unapproved')"></el-option>
                            <el-option style="font-size:12px" :value="DEVICE_MANAGEMENT_STATUS_APPROVED"
                                :label="$t('message.item_approval_status_approved')"></el-option>
                        </el-select>
                    </div>
                    <div v-else-if="conditionType === 'active'">
                        <el-select :placeholder="$t('message.place_holder_select_item')" v-model="active"
                            class="object-search-select" style="padding-left:0px;width:350px;">
                            <el-option style="font-size:12px" :value="true"
                                :label="$t('message.item_device_management_active')"></el-option>
                            <el-option style="font-size:12px" :value="false"
                                :label="$t('message.item_device_management_inactive')"></el-option>
                        </el-select>
                    </div>
                    <div v-else>
                        <el-input :placeholder="$t('message.place_holder_input_text')" class="object-search-select"
                            style="padding-left:0px;width:280px;" :disabled="true" />
                    </div>
                    <div style="width: 100px;">
                        <el-button class="search-button" native-type="submit" v-t="'message.action_search_items'"
                            :disabled="disabledSearchButton" />
                    </div>
                </div>
            </el-form>
        </div>
        <div style="height: calc(100vh - 490px); overflow-y: scroll;">
            <table style="width: 100%;">
                <tr class="table-column">
                    <td class="object-item1" style="width:30%" v-t="'message.item_device_id'"></td>
                    <td class="object-item1" style="width:15%" v-t="'message.item_approval_status'"></td>
                    <td class="object-item1" style="width:15%" v-t="'message.item_active_user_name'"></td>
                    <td class="object-item1" style="width:20%" v-t="'message.item_created_at'"></td>
                    <td class="object-item1" style="width:10%"></td>
                    <td class="object-item1" style="width:10%"></td>
                </tr>
                <tr class="table-record" v-for="(device, index) in cachedDeviceManagementList[currentPage]">
                    <td class="object-item1" style="width:30%"> {{ device.deviceId }} </td>
                    <td class="object-item1" style="width:15%"> {{ getStatusName(device.approvalStatus) }} </td>
                    <td class="object-item1" style="width:15%"> {{ device.activeUserName }} </td>
                    <td class="object-item1" style="width:20%"> {{ displayDateTime(device.createdAt) }} </td>
                    <td class="object-item2" style="width:10%">
                        <button v-if="device.approvalStatus !== 1" class="transparent-button" type="button"
                            v-on:click="showUpdateDialog(device.deviceId, DEVICE_MANAGEMENT_STATUS_APPROVED, index)">
                            <span style="color: #5171cb" v-t="'message.action_device_management_approve'"></span>
                        </button>
                    </td>
                    <td class="object-item2" style="width:10%">
                        <button class="transparent-button" type="button"
                            v-on:click="showDeleteDialog(device.deviceId, index)">
                            <span style="color: #d55169" v-t="'message.action_device_management_delete'"></span>
                        </button>
                    </td>
                </tr>
            </table>
        </div>
        <div class="pagination-container" v-if="total !== 0">
            <el-button icon="el-icon-arrow-left" type="text" class="pagination-button" @click="prevClick"
                :disabled="currentPage <= 1"></el-button>
            <span> {{ currentPage }} / {{ totalPages }} </span>
            <el-button icon="el-icon-arrow-right" type="text" class="pagination-button" @click="nextClick"
                :disabled="currentPage >= totalPages"></el-button>
        </div>
        <ComformDialog v-if="showDialog" :dialogData="dialogData" @update="updateDeviceManagementApprovalStatus"
            @delete="deleteDeviceManagement" @cancel="showDialog = false"></ComformDialog>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import ComformDialog from "@/components/pc/setting/devicemanagement/ComformDialog";

export default {
    components: {
        ComformDialog: ComformDialog,
    },
    data() {
        return {
            searchString: "",
            searchApprovalStatus: constants.DEVICE_MANAGEMENT_STATUS_UNAPPROVED,
            active: true,
            conditionType: "approvalStatus",
            currentIndex: null,
            showDialog: false,
            dialogData: {
                action: "",
                emit: "",
                payload: {},
            },
            isSearching: false,
            loadingScreen: null,
            // paging
            cachedDeviceManagementList: {}, // item = {deviceId, approvalStatus, createdAt}
            total: 0,
            pageSize: constants.DEVICE_MANAGEMENT_PAGINATION_SIZE,
            currentPage: 1,
            // constants
            DEVICE_MANAGEMENT_STATUS_UNAPPROVED: constants.DEVICE_MANAGEMENT_STATUS_UNAPPROVED,
            DEVICE_MANAGEMENT_STATUS_APPROVED: constants.DEVICE_MANAGEMENT_STATUS_APPROVED,
        };
    },
    created() {
        // for initial display set pending data
        this.getDeviceManagementList(this.conditionType, this.searchString, this.searchApprovalStatus, this.active, true, false);
    },
    mounted() {
    },
    computed: {
        totalPages() {
            return Math.ceil(this.total / this.pageSize);
        },
        disabledSearchButton() {
            if (this.isSearching) return true;
            if (this.conditionType == "deviceId" && (this.searchString === "" || this.searchString.length !== 32)) return true;
            return false;
        }
    },
    watch: {
    },
    methods: {
        showLoadingScreen() {
            if (this.loadingScreen == null) {
                this.loadingScreen = this.$loading({
                    lock: true,
                    text: 'Loading data ...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0)'
                });
            }
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        getStatusName(approvalStatus) {
            return commonUtil.getDeviceManagementApprovalStatusName(this.$i18n, approvalStatus);
        },
        displayDateTime(createdAt) {
            return new Date(createdAt)
                .toLocaleString(undefined,
                    {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: false,
                    })
                .replace(/\//g, "/")
                .replace(",", "");
        },
        async getDeviceManagementList(conditionType, deviceId, approvalStatus, active, init = false, reload = false) {
            // check cache
            if (init || reload) {
                this.total = 0;
                this.currentIndex = 1;
                this.currentPage = 1;
                this.cachedDeviceManagementList = {}
            } else {
                if (this.currentPage in this.cachedDeviceManagementList) return;
            }

            const upperDeviceId = this.currentPage > 1 ? this.cachedDeviceManagementList[this.currentPage - 1].slice(-1)[0].deviceId : null
            const payload = { conditionType, deviceId, approvalStatus, active, upperDeviceId };
            try {
                this.deviceManagementList = [];
                this.isSearching = true;
                this.showLoadingScreen();
                const { data } = await server.post("/getdevicemanagementlist", payload);
                switch (data.status) {
                    case constants.STATUS_SUCCESS:
                        if (init || reload) {
                            this.total = data.total;
                            // message when only init
                            if (init && data.deviceManagementList.length > 0) {
                                commonUtil.notifyMessage(this, "Info", commonUtil.getMessageText(this.$i18n, "info_device_management_has_unapproved"));
                            }
                        }
                        this.$set(this.cachedDeviceManagementList, this.currentPage, data.deviceManagementList)
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getDeviceManagementList").replace("{code}", data.status));
                        break;
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "getDeviceManagementList", error);
            } finally {
                this.setSearchingFalseDelay();
                this.closeLoadingScreen();
            }
        },
        async updateDeviceManagementApprovalStatus(payload) {
            // payload = { deviceId, approvalStatus }
            try {
                const { data } = await server.post("/updatedevicemanagementapprovalstatus", payload)
                switch (data.status) {
                    case constants.STATUS_SUCCESS:
                        this.$set(this.cachedDeviceManagementList[this.currentPage][this.currentIndex], 'approvalStatus', payload.approvalStatus);
                        commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "info_device_management_updated"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "updateDeviceManagementApprovalStatus").replace("{code}", data.status));
                        break;
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "updateDeviceManagementApprovalStatus", error);
            } finally {
                this.showDialog = false;
            }
        },
        async deleteDeviceManagement(payload) {
            // payload = { deviceId }
            try {
                const { data } = await server.post("/deletedevicemanagement", payload)
                switch (data.status) {
                    case constants.STATUS_SUCCESS:
                    case constants.STATUS_ERROR_NOT_FOUND:
                        this.cachedDeviceManagementList[this.currentPage].splice(this.currentIndex, 1);
    
                        let successMsg = commonUtil.getMessageText(this.$i18n, "info_device_management_deleted");
                        if (data.activeUserName) {
                            successMsg += commonUtil.getMessageText(this.$i18n, "info_device_management_force_logout").replace("{activeUserName}", data.activeUserName)
                        }
                        commonUtil.notifyMessage(this, 'Success', successMsg);
                        break;
                    case constants.STATUS_ERROR_TALKGROUP_NOT_FOUND:
                        this.cachedDeviceManagementList[this.currentPage].splice(this.currentIndex, 1);
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_device_management_force_logout").replace("{activeUserName}", data.activeUserName));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "deleteDeviceManagement").replace("{code}", data.status));
                        break;
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "deleteDeviceManagement", error);
            } finally {
                this.showDialog = false;
            }
        },
        async showUpdateDialog(deviceId, approvalStatus, index) {
            this.currentIndex = index;
            this.dialogData.action = "approve";
            this.dialogData.emit = "update"
            this.dialogData.payload = { deviceId, approvalStatus };
            this.showDialog = true;
        },
        async showDeleteDialog(deviceId, index) {
            this.currentIndex = index;
            this.dialogData.action = "delete";
            this.dialogData.emit = "delete"
            this.dialogData.payload = { deviceId };
            this.showDialog = true;
        },
        setSearchingFalseDelay() {
            setTimeout(() => {
                this.isSearching = false;
            }, 1000);
        },
        prevClick() {
            if (this.isSearching) return;
            this.currentPage = this.currentPage - 1;
            this.getDeviceManagementList(this.conditionType, this.searchString, this.searchApprovalStatus, this.active);
        },
        nextClick() {
            if (this.isSearching) return;
            this.currentPage = this.currentPage + 1;
            this.getDeviceManagementList(this.conditionType, this.searchString, this.searchApprovalStatus, this.active);
        },
    },
}
</script>
<style>
.el-select .el-input__inner {
    cursor: pointer;
    border-radius: 0;
    color: #606266;
    background-color: #fafafa;
}
</style>

<style scoped>
.treetitle {
    padding-top: 10px;
    padding-bottom: 10px;
    /* padding-left: 20px; */
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    /* background-color: #f6f6f6; */
    color: #848991;
}

.table-column {
    background-color: #f6f6f6;
    color: #848991;
}

.table-record {
    background-color: transparent;
    border-bottom: solid 1px #eee;
}

.table-record:hover {
    background-color: #ecf1fa;
}

.object-item1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    font-size: 12px;
}

.object-item2 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 28px;
    font-size: 12px;
    width: 10%;
    text-align: center;
}

.pagination-container {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: medium;
}

.pagination-button {
    background-color: white;
    color: #333b48;
    font-size: 20px;
    margin: 0 5px;
}

.pagination-button:disabled {
    background-color: transparent;
    color: #c0c4cc;
    cursor: not-allowed;
}

.pagination-button:hover:not(:disabled) {
    background-color: transparent;
    color: #5171cb;
}
</style>
